import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import {initReactI18next} from 'react-i18next'
import { readLanguageFromCookie } from "./main/components/GeneralUtils";
import tenantService from "/src/main/services/TenantService";
import { changeLanguage } from "./main/components/language/LanguageSelector";

const lang = readLanguageFromCookie();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: lang,
    backend: {
      /* translation file path */
      loadPath: '/services/content/assets/i18n/{{ns}}/{{lng}}.json'
    },
    fallbackLng: "en",
    debug: false,
    /* translations are default for de-did and initialized as default and also as fallback just because i18n cant handle async back call to determine the tenant */
    ns: ['translations'],
    fallbackNS: 'translations',
    defaultNS: 'translations',
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true,
      useSuspense: true,
      transKeepBasicHtmlNodesFor: ['ul', 'li', 'table', 'tbody', 'b', 'td', 'tr', 'br', 'p', 'h4', 'h2', 'u', 'strong', 'div', '&shy;']
    }
  });


tenantService.getTenant().then(tenant => {
  i18n.setDefaultNamespace(tenant);
  /* default language should be now set by the tenant service */
  const lang = readLanguageFromCookie();
  changeLanguage(lang)
});

window.addEventListener("languagechange", function (event) {
    const language = event.detail.language;
    i18n.changeLanguage(language).then(() => {});
});


export default i18n
